import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/guards/auth.guard';

const routes: Routes = [

  { path: '', loadChildren: () => import('../app/auth/auth.module').then(m => m.AuthModule) },
  { path: 'core', loadChildren: () => import('../app/core/core.module').then(m => m.CoreModule) },
  { path: 'opd', canActivate: [AuthGuard], loadChildren: () => import('../app/opd/opd.module').then(m => m.OpdModule) },
  { path: 'administration', canActivate: [AuthGuard], loadChildren: () => import('../app/administration/administration.module').then(m => m.AdministrationModule) },
  { path: 'ui-elements', canActivate: [AuthGuard], loadChildren: () => import('../app/ui-elements/ui-elements.module').then(m => m.UiElementsModule) },
  { path: 'prescription', canActivate: [AuthGuard], loadChildren: () => import('../app/prescription/prescription.module').then(m => m.PrescriptionModule) },
  { path: 'emr', canActivate: [AuthGuard], loadChildren: () => import('../app/emr/emr.module').then(m => m.EmrModule) },
  { path: 'campaign', canActivate: [AuthGuard], loadChildren: () => import('../app/camping/camping.module').then(m => m.CampingModule) },
  // { path: 'dashboard', canActivate: [AuthGuard], loadChildren: () => import('../app/dashboard/dashboard.module').then(m => m.DashboardModule) },
    { path: 'patient-list-dashboard', canActivate: [AuthGuard], loadChildren: () => import('../app/patient-list-dashboard/patient-list-dashboard.module').then(m => m.PatientListDashboardModule) },
    { path: 'report', canActivate: [AuthGuard], loadChildren: () => import('../app/reports/reports.module').then(m => m.ReportsModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
